module.exports = __webpack_public_path__ + "img/progressico.e2e40162.png";